import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2022-10-12T11:00",
		title: `
<h4>燕・弥彦医療介護センターより</h4>
<p class="paragraph-indent">
●燕市医師会市民公開講座/つばめ・やひこ医療・福祉・介護フォーラム2022開催のご案内<br>
・<a href="${topicsDir}/2022/10-tsubameyahiko-forum2022.pdf">チラシ/申込書</a><br>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
